"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ServiceLogsComponent = _interopRequireDefault(require("../../components/ServiceLogs/ServiceLogsComponent"));
var _images = _interopRequireDefault(require("../../common_features/assets/images"));
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _moment = _interopRequireDefault(require("moment"));
var _systemsReducer = require("../../common_features/redux/reducers/systemsReducer");
var _RoutePath = _interopRequireDefault(require("../../RoutePath"));
var _Services = require("../../common_features/utility/Services");
var _helper = require("../../common_features/utility/helper");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const _ = require("underscore");
const ServiceLogs = () => {
  const navigate = (0, _reactRouterDom.useNavigate)();
  const dispatch = (0, _reactRedux.useDispatch)();
  const [logData, setLogData] = (0, _react.useState)([]);
  const [count, setcount] = (0, _react.useState)(1);
  const [load, setLoadMore] = (0, _react.useState)(false);
  const {
    selectedSystems,
    filterData
  } = (0, _reactRedux.useSelector)(state => state.systems);
  const [listItem, setListItem] = (0, _react.useState)([]);
  const [page, setPage] = (0, _react.useState)(filterData !== null && filterData !== void 0 && filterData.page ? filterData === null || filterData === void 0 ? void 0 : filterData.page : 1);
  const [filterTypes, setFilterTypes] = (0, _react.useState)(filterData !== null && filterData !== void 0 && filterData.filterTypes ? [...(filterData === null || filterData === void 0 ? void 0 : filterData.filterTypes)] : []);
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const [fromDate, setFromDate] = (0, _react.useState)(filterData !== null && filterData !== void 0 && filterData.fromDate ? filterData === null || filterData === void 0 ? void 0 : filterData.fromDate : "");
  const [toDate, setToDate] = (0, _react.useState)(filterData !== null && filterData !== void 0 && filterData.toDate ? filterData === null || filterData === void 0 ? void 0 : filterData.toDate : "");
  const [showModal, setShowModal] = (0, _react.useState)(false);
  const [fetchDataFlag, setFetchData] = (0, _react.useState)(false);
  const [deleteChip, setDeleteChip] = (0, _react.useState)(false);
  const [resetFilterData, setResetFilterData] = (0, _react.useState)(false);
  const [servicesArray, setServicesArray] = (0, _react.useState)(filterData !== null && filterData !== void 0 && filterData.servicesArray ? [...(filterData === null || filterData === void 0 ? void 0 : filterData.servicesArray)] : [{
    isChecked: false,
    title: "Select All",
    textStyle: {
      fontWeight: 600
    }
  }, {
    isChecked: false,
    title: "Filter Updated",
    type: "4"
  }, {
    isChecked: false,
    title: "System Added",
    type: "1"
  }, {
    isChecked: false,
    title: "System Updated",
    type: "2"
  }, {
    isChecked: false,
    title: "Accessory Updated",
    type: "6"
  }, {
    isChecked: false,
    title: "Water Destination Updated",
    type: "3"
  }, {
    isChecked: false,
    title: "Water Info Updated",
    type: "7"
  }, {
    isChecked: false,
    title: "Photos Updated",
    type: "8"
  }, {
    isChecked: false,
    title: "Accessory Added",
    type: "5"
  }]);
  const [tempServicesArray, setTempServicesArray] = (0, _react.useState)([]);
  const fetchDate = date => {
    const isFilterApplied = filterTypes.length > 0 || !!toDate && !!fromDate;
    const today = new Date(Date.now());
    const dateValue = (0, _helper.formatDateString)(new Date(date));
    if (!isFilterApplied) {
      if (dateValue === (0, _helper.formatDateString)(today)) {
        return "Today";
      } else if (isYesterday(new Date(date))) {
        return "Yesterday";
      }
    }
    return (0, _moment.default)(new Date(date)).format('MMM DD, YYYY');
  };
  const isYesterday = dateToCheck => {
    const currentDate = new Date();
    const yesterday = new Date(currentDate);
    yesterday.setDate(currentDate.getDate() - 1);
    return dateToCheck.getDate() === yesterday.getDate() && dateToCheck.getMonth() === yesterday.getMonth() && dateToCheck.getFullYear() === yesterday.getFullYear();
  };
  const fetchServiceLogData = async () => {
    var _resp$data, _resp$data2, _resp$data3, _resp$data3$rows;
    let serviceLogsType = [...filterTypes];
    const _fromDate = !!fromDate ? (0, _moment.default)(fromDate).format('YYYY-MM-DD') : null;
    const _toDate = !!toDate ? (0, _moment.default)(toDate).format('YYYY-MM-DD') : null;
    if (serviceLogsType.length == 0) serviceLogsType = ['1', '2', '3', '4', '5', '6', '7', '8'];
    const systemId = selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.systemId;
    setIsLoading(true);
    const resp = await (0, _Services.getServiceLogOperations)(systemId, page, serviceLogsType, _fromDate, _toDate);
    setIsLoading(false);
    setFetchData(false);
    setcount(resp === null || resp === void 0 ? void 0 : (_resp$data = resp.data) === null || _resp$data === void 0 ? void 0 : _resp$data.count);
    const newList = [...(resp === null || resp === void 0 ? void 0 : (_resp$data2 = resp.data) === null || _resp$data2 === void 0 ? void 0 : _resp$data2.rows)];
    setLogData(prev => [...prev, ...newList]);
    const groupedDate = _.groupBy((_resp$data3 = resp['data']) === null || _resp$data3 === void 0 ? void 0 : (_resp$data3$rows = _resp$data3.rows) === null || _resp$data3$rows === void 0 ? void 0 : _resp$data3$rows.filter(item => item.onDate), 'onDate');
    if (page > 1) setListItem({
      ...listItem,
      ...groupedDate
    });else setListItem({
      ...groupedDate
    });
  };
  const onClickLoadMore = async () => {
    setPage(page + 1);
  };
  (0, _react.useEffect)(() => {
    setLogData(prev => [...prev, ...logData]);
    fetchServiceLogData();
  }, [page]);
  (0, _react.useEffect)(() => {
    loadVisible();
  }, [count, page]);
  (0, _react.useEffect)(() => {
    const index = servicesArray.find(item => item.isChecked == true);
    if (index == undefined) {
      setFilterTypes([]);
    }
  }, [servicesArray]);
  (0, _react.useEffect)(() => {
    if (resetFilterData) {
      dispatch((0, _systemsReducer.setSelectedFilterData)({
        servicesArray: [...servicesArray],
        filterTypes: [],
        page: 1,
        fromDate: "",
        toDate: ""
      }));
      setResetFilterData(false);
    }
  }, [resetFilterData]);
  (0, _react.useEffect)(() => {
    if (fetchDataFlag) fetchServiceLogData();
  }, [fetchDataFlag]);
  (0, _react.useEffect)(() => {
    if (deleteChip) {
      onApplyFilters();
      setDeleteChip(false);
    }
  }, [deleteChip]);
  const onBackPress = () => {
    navigate(-1);
  };
  const loadVisible = () => {
    if (count > 3 && count / 3 > 1 && page < count / 3) {
      setLoadMore(true);
    } else {
      setLoadMore(false);
    }
  };
  const operationClicked = (item, index) => {
    dispatch((0, _systemsReducer.serviceLog)(item[index]));
    navigate(_RoutePath.default.serviceLogOperations.useLink);
  };
  const handleModal = () => {
    setShowModal(!showModal);
  };
  const handleFilterClick = () => {
    let arr = Array.from(servicesArray);
    setTempServicesArray([...arr]);
    handleModal();
  };
  const modalCrossClick = () => {
    setServicesArray([...tempServicesArray]);
    handleModal();
  };
  const onApplyFilters = () => {
    const dateObj = !!fromDate && !!toDate ? {
      fromDate: fromDate,
      toDate: toDate
    } : {};
    let typesArray = [];
    servicesArray.forEach((item, index) => {
      if (item.isChecked && index != 0) typesArray.push(item.type);
    });
    setShowModal(false);
    setFilterTypes([...typesArray]);
    setPage(1);
    setFetchData(true);
    dispatch((0, _systemsReducer.setSelectedFilterData)({
      servicesArray: [...servicesArray],
      filterTypes: [...typesArray],
      page: page,
      ...{
        ...dateObj
      }
    }));
  };
  const onClearFilters = () => {
    let arr = [...servicesArray];
    let newArr = [];
    newArr = arr.map(item => ({
      ...item,
      isChecked: false
    }));
    setServicesArray([...newArr]);
    setFromDate("");
    setToDate("");
    setFilterTypes([]);
    setPage(1);
    setShowModal(false);
    setFetchData(true);
    setResetFilterData(true);
  };
  const onChangeCheckBox = index => {
    let arr = [...servicesArray];
    let newArr = [];
    if (index == 0) {
      let value = true;
      if (servicesArray[index].isChecked) value = false;
      newArr = arr.map(item => ({
        ...item,
        isChecked: value
      }));
    } else {
      newArr = arr.map((item, i) => index == i ? {
        ...item,
        isChecked: !item.isChecked
      } : item);
    }
    setServicesArray([...newArr]);
  };
  const onDeleteChip = item => {
    if (item == "date") {
      setFromDate("");
      setToDate("");
      setFetchData(true);
      return;
    } else {
      let newArr = servicesArray.map((_item, index) => {
        if (index == item || index == 0) return {
          ..._item,
          isChecked: false
        };else return _item;
      });
      setServicesArray([...newArr]);
    }
    setShowModal(false);
    setDeleteChip(true);
  };
  const getSelectedChipList = () => {
    let flag = servicesArray.find((item, index) => item.isChecked == true);
    if (flag) return servicesArray;else return [];
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ServiceLogsComponent.default, {
    isDesktop: window.innerWidth >= 720,
    servicesLabel: servicesArray,
    selectedChipsList: getSelectedChipList(),
    checkBoxesLabel: "Select Services",
    chipContainerLabel: "Filtered By:",
    modalDropdownData: {
      displayModal: showModal,
      modalHeaderTextStyle: {
        textAlign: "start",
        paddingLeft: "20px",
        paddingTop: "20px",
        fontSize: "18px"
      },
      displayCrossIcon: true,
      positiveActionButtonTitle: "Apply",
      negativeButtonActionTitle: "Clear All",
      showDateRange: true,
      divStyleBtn1: {
        marginLeft: "20px",
        marginRight: "20px",
        marginTop: "50px"
      },
      divStyleBtn2: {
        marginLeft: "20px",
        marginRight: "20px",
        marginBottom: "50px"
      },
      btn2Style: {
        borderWidth: "2px"
      },
      variant: "filter",
      crossIconAction: modalCrossClick,
      positiveAction: onApplyFilters,
      negativeAvtion: onClearFilters
    },
    handleModal: handleFilterClick,
    inputLabelFrom: "From",
    inputLabelTo: "To",
    fromValue: fromDate,
    toValue: toDate,
    fromDateFormatted: (0, _moment.default)(fromDate).format('MMM DD,YYYY'),
    toDateFormatted: (0, _moment.default)(toDate).format('MMM DD,YYYY'),
    onChangeCheckBox: onChangeCheckBox,
    onDeleteChip: onDeleteChip,
    fromDateChange: setFromDate,
    toDateChange: setToDate,
    navHeading: "System Dashboard",
    handleBack: onBackPress,
    leftArrow: _images.default.leftArrow.default,
    rightNavHeading: 'Cancel',
    headerText: "Service History",
    systemName: selectedSystems.systemModelNumber,
    systemPartNumber: selectedSystems.systemPartNumber,
    listItem: listItem,
    isLoading: isLoading,
    arrowIcon: _images.default.ArrowRight.default,
    operationClicked: operationClicked,
    fetchDate: fetchDate,
    loadMoreButton: 'Load More',
    loadVisible: load,
    onClickLoadMore: onClickLoadMore
  }));
};
var _default = exports.default = ServiceLogs;